var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconWarningFill = function IconWarningFill(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.403 18.947h-1.078c-.932-4.521-1.38-6.428-1.38-7.106a1.92 1.92 0 113.84 0c0 .678-.353 2.43-1.382 7.106zm-.539 5.973a1.92 1.92 0 110-3.84 1.92 1.92 0 010 3.84zm14.143-.48c-1.426-3.123-4.667-8.883-7.248-13.207-5.327-8.927-6.155-9.345-6.895-9.217-.75-.127-1.569.29-6.896 9.217-2.58 4.324-5.82 10.084-7.248 13.207-.553 1.21-1.037 2.27-.459 2.922.213.564 1.018 2.156 14.603 2.156 13.584 0 14.39-1.592 14.603-2.156.578-.651.094-1.711-.46-2.922z",
    clipRule: "evenodd"
  }));
};

IconWarningFill.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconWarningFill;
//# sourceMappingURL=IconWarningFill.js.map